import React from "react";
import { INiche } from "@/common/services/types";
import { Image } from "@/components/UI/Image";
import { nFormatter } from "@/common/utils/parseNumber";
import UsersIcon from "@/common/images/icons/users.svg?react";
import "./NicheListItem.scss";
import { useSfw } from "@/common/hooks/useSfw";

interface INicheExtended extends Omit<INiche, "name" | "description" | "cover"> {
  name: string | React.ReactElement;
}

interface INicheListItem {
  niche: INicheExtended;
  actionElement?: React.ReactNode;
}

export const NicheListItem: React.FC<INicheListItem> = ({
  niche,
  actionElement = null
}) => {
  const { sanitizeImage, isLoading } = useSfw();
  const thumbnail = niche.thumbnail ? sanitizeImage(niche.thumbnail) : null;

  if (isLoading) {
    return null;
  }

  return (
    <div className="NicheListItem" data-testid={niche.id}>
      <div className="NicheListItem-Info">
        <Image className="NicheThumb" src={thumbnail} />
        <div className="NicheTexts">
          <div className="Name">{niche.name}</div>
          <div className="Subscribes">
            <UsersIcon />
            <span>{nFormatter(niche.subscribers)}</span>
          </div>
        </div>
      </div>
      { actionElement }
    </div>
  );
};
